import { components, useApi } from "@appretio/api";
import { ContextSelectedOptions } from "@appretio/context-selector";
import { useQuery } from "@tanstack/react-query";
import { TemporalContext } from "../../../components/temporalContextSelector/data/temporalContextOptions";
import { convertOptionsToApiFormat } from "../utils/convertToApiFormat";
import { trendLineQueryKeys } from "./queryKeys";

export type TrendLineResponse = components["schemas"]["TrendLine"] | never[];

export function useFetchTrendLine(
  contextOptions: ContextSelectedOptions,
  temporalOptions: TemporalContext,
  enabled: boolean = false
) {
  const apiClient = useApi();

  return useQuery({
    queryKey: trendLineQueryKeys.data({ contextOptions, temporalOptions }),
    queryFn: async () => {
      const options = convertOptionsToApiFormat(
        contextOptions,
        temporalOptions
      );

      try {
        const response = await apiClient.POST(
          "/v1/in-season/review/get-trendline",
          {
            body: {
              ...options,
              query_params: {
                offset: 0
              }
            }
          }
        );

        return (response.data?.result as TrendLineResponse) ?? [];
      } catch (error) {
        console.error("Error fetching context options:", error);

        throw error; // Let TanStack Query handle the error state
      }
    },
    enabled,
    staleTime: 5 * 60 * 1000
  });
}
